import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

import { BackendRoutePerformanceResponse, ObservabilityRangePreset } from '../../models/observability/backend-route-performance.model';

@Injectable({ providedIn: 'root' })
export class ObservabilityService {
  constructor(private readonly restangular: ApiClient) {}

  getBackendRoutePerformance(range: ObservabilityRangePreset): Promise<BackendRoutePerformanceResponse> {
    return this.restangular.one('v5').one('admin').one('observability').one('backend').one('routes')
      .get({ range }).toPromise().then((response: BackendRoutePerformanceResponse) => response);
  }
}
